import * as React from 'react';
import { useState, useEffect } from "react";
import axios from 'axios';
import Sidebar from '../components/sidebar'
import Footer from '../components/footer'
import Head from '../components/head'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function Main() {
  const [name,setName]=useState('')
  const [review,setReview]=useState('')
  const [des,setDes]=useState('')
  const [star,setStar]=useState('')
  const [extra,setExtra]=useState('')
  const [img,setImage]=useState('https://eimantravels.co.uk/images/hotel/')
  const [pr,setPr]=useState('')
  const [extra2,setExtra2]=useState('')

  // Quill editor modules configuration
  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'color': [] }, { 'background': [] }],
      ['clean']
    ],
  };

  const getDb = async ()=> {
    const data = new FormData();  
    data.append('name',name);
    data.append('review',review);
    data.append('des',des);
    data.append('star',star);
    data.append('ex',extra);
    data.append('img',img);
    data.append('ex2',extra2);
    data.append('pr',pr);

    axios({
      method: 'post',
      url: '/api/hotel/add.php',
      data: data,
      headers: {'Content-Type': 'multipart/form-data'},
    })
      .then(s => {
        console.log("run")
        if(s.data[0].msg=="already") {
          alert("already hotel here")
        } else if(s.data[0].msg=="fail") {
          alert("Fail here")
        } else {
          alert("Saved here")
        }
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  return (
    <>
     <div className="main-wrapper">
        <Sidebar />
        <div className="page-wrapper">
          <Head />
          <div>
            <div className="page-content">
              <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="mb-4">New Hotel </h4>
                      <div className="row">
                        <div className="col-lg-4 mb-3">
                          <label htmlFor="fullname" className="form-label">
                            Hotel Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="fullname"
                            autoComplete="off"
                            placeholder=""
                            value={name} onChange={(v)=>{ setName(v.target.value)}}
                          />
                        </div>
                        <div className="col-lg-1 mb-3">
                          <label htmlFor="email" className="form-label">
                            Review
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="email"
                            autoComplete="off"
                            placeholder=""
                            value={review} onChange={(v)=>{ setReview(v.target.value)}}
                          />
                        </div>

                        <div className="col-lg-1 mb-3">
                          <label htmlFor="fullname" className="form-label">
                            Price
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="fullname"
                            autoComplete="off"
                            placeholder=""
                            value={pr} onChange={(v)=>{ setPr(v.target.value)}}
                          />
                        </div>
                        <div className="col-lg-4 mb-3">
                          <label htmlFor="email" className="form-label">
                            Extra 2
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="email"
                            autoComplete="off"
                            placeholder=""
                            value={extra2} onChange={(v)=>{ setExtra2(v.target.value)}}
                          />
                        </div>
                        
                        <div className="col-lg-12 mb-3">
                          <label htmlFor="password" className="form-label">
                            Description
                          </label>
                          <ReactQuill
                            theme="snow"
                            value={des}
                            onChange={setDes}
                            modules={modules}
                            style={{ height: '200px', marginBottom: '50px' }}
                          />
                        </div>

                        <div className="col-lg-6 mb-3">
                          <label htmlFor="password" className="form-label">Star of Hotel</label>
                          <select  value={star} onChange={(v)=>{ setStar(v.target.value)}} className='form-control'>
                            <option></option>
                            <option>star</option>
                            <option>1-star</option>
                            <option>2-star</option>
                            <option>3-star</option>
                            <option>4-star</option>
                            <option>5-star</option>
                            <option>7-star</option>
                          </select>
                        </div>

                        <div className="col-lg-6 mb-3">
                          <label htmlFor="password" className="form-label">Select Makkah / Madinah</label>
                          <select  value={extra} onChange={(v)=>{ setExtra(v.target.value)}} className='form-control'>
                            <option></option>
                            <option>Makkah</option>
                            <option>Madinah</option>
                          </select>
                        </div>

                        <div className="col-lg-12 mb-3">
                          <label htmlFor="password" className="form-label">
                              Image Path / URL
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="password"
                            autoComplete="off"
                            placeholder=""
                            value={img} onChange={(v)=>{ setImage(v.target.value)}}
                          />
                        </div>
              
                        <div>
                          <button  className="btn btn-primary" onClick={()=>{
                            getDb();
                          }} >
                            <i className="link-icon" data-feather="plus" /> New Hotel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer/>
        </div>
      </div>
    </>
  )
}